import "../node_modules/bootstrap/dist/css/bootstrap.css";
import "../node_modules/font-awesome/css/font-awesome.css";
import "../node_modules/rc-select/assets/index.css";
import "../node_modules/rc-calendar/assets/index.css";
import "../node_modules/rc-dialog/assets/bootstrap.css";
import "../node_modules/simplemde/dist/simplemde.min.css";
import '../style/dashboard.css';
import '../style/editor.css';
import '../style/style.css';
import '../style/se.css';

import queryString = require('query-string');
const query = queryString.parse(location.search);

import configureLocale from './locale/configureLocale';
const locale = configureLocale(query.lang);

import * as React from 'react';
import { Provider } from 'react-redux';
import * as DOM from 'react-dom';

import AppContainer from './components/AppContainer';
import EditorApp from './components/EditorApp';

import configureApi from './api/configureApi';
import configureStore from './store/configureStore';

const api = configureApi();
const store = configureStore({
    reportSettings: {
        isEditor: true,
    }
});

DOM.render(
    <Provider store={store}>
        <AppContainer>
            <EditorApp />
        </AppContainer>
    </Provider>,
    document.getElementById('react')
);


// WEBPACK FOOTER //
// ./src/index.tsx